import React, { Component } from 'react'
import RoleForm from '../_Components/RoleForm'
import TelehealthAccessCard from '../_Components/TelehealthAccessCard'

import { connect } from 'react-redux'
import { abilities } from '../../../../_constants/abilities.constants'
import { alertActions } from '../../../../_actions/alert.actions'
import { rolesService } from '../../../../_services/roles.service'
import { Row, Col, Button, Spinner } from 'react-bootstrap'
import httpStatus from 'http-status'

class AddRole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role: '',
      form: [],
      users: [],
      errors: [],
      events: [],
      adding: false,
      library: [],
      billing: [],
      messages: [],
      locations: [],
      telehealth: [],
      roles: [],
      description: '',
      showTelehealthAccessCard: false
    }

    this.handleAdd = this.handleAdd.bind(this)
    this.handleCreateRoleObject = this.handleCreateRoleObject.bind(this)
  }

  handleAdd() {    
    this.props.dispatch(alertActions.clear());

    let errors = {}

    if (this.state.role === '') {
      errors.role = 'Please enter a role name.'
    }

    if (this.state.description === '') {
      errors.description = 'Please enter a description.'
    }

    if (
      this.state.form.length === 0 &&
      this.state.users.length === 0 &&
      this.state.roles.length === 0 &&
      this.state.events.length === 0 &&
      this.state.library.length === 0 &&
      this.state.billing.length === 0 &&
      this.state.messages.length === 0 &&
      this.state.locations.length === 0 &&
      this.state.telehealth.length === 0 
   ) {
    errors.permissions = false;

    window.scroll(0,0)

    this.props.dispatch(alertActions.error('At least one permission must be selected for a role.'));
   }

    this.setState({errors: errors})

    if (Object.values(errors).length === 0) {
      // this.setState({adding: true})

      const role = this.handleCreateRoleObject()

      rolesService.addRole(role)
        .then(() => {
          this.props.history.push('/account/roles')
          this.props.dispatch(alertActions.success('Role successfully created!'));
        })
        .catch((error) => {
          this.setState({adding: false})

          window.scroll(0,0)

          if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
            this.props.dispatch(alertActions.error(error.response.data.message));
          } else {
            this.props.dispatch(alertActions.error('Could not add role at this time. Please try again.'));
          }
        })
    } 
  }

  handleCreateRoleObject = () => {
    const role = {
      name: this.state.role,
      title: this.state.description
    }
    abilities.forEach((ability) => {
      const name = ability.split('-')[0]

      role[ability] = this.state[name].includes(ability)
    })
    return role
  }

  render() {
    const { adding } = this.state

    return (
      <>
        <header className='mb-4'>
          <div className='lead py-2'>Add Role</div>
          <div className='font-weight-light'>Add a role by entering the name and selecting the allowed permissions</div>
        </header>

        <Row>
          <Col lg='9' xl='7'>
            <RoleForm 
              state={this.state}
              errors={this.state.errors}
              setState={(stateValues) => {
                this.setState(stateValues)
              }}
            >
              <Row className='mt-4 pt-3 px-3'>
                <Col xs='3'>
                  <Button disabled={adding} onClick={() => { this.props.history.push('/account/roles') }} block variant='outline-secondary'>Cancel</Button>
                </Col>
                <Col xs={{span: 4, offset: 5}}>
                  <Button disabled={adding} onClick={this.handleAdd} block variant='success'>
                    { adding ? <Spinner size='sm' animation='border'/> : 'Add Role' }
                  </Button>
                </Col>
              </Row>
            </RoleForm>
          </Col>
          <Col xs='4'>
            { this.state.showTelehealthAccessCard && 
              <TelehealthAccessCard handleClose={() => this.setState({showTelehealthAccessCard: false})}/> }
          </Col>
        </Row>
      </>
    )
  }
}

export default connect()(AddRole);
